var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownRightArrowBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2ZM7.53033 6.46967C7.23744 6.17678 6.76256 6.17678 6.46967 6.46967C6.17678 6.76256 6.17678 7.23744 6.46967 7.53033L15.1893 16.25H8.80328C8.38906 16.25 8.05328 16.5858 8.05328 17C8.05328 17.4142 8.38906 17.75 8.80328 17.75H17C17.4142 17.75 17.75 17.4142 17.75 17V8.80328C17.75 8.38906 17.4142 8.05328 17 8.05328C16.5858 8.05328 16.25 8.38906 16.25 8.80328V15.1893L7.53033 6.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRightArrowBox);
export default __webpack_public_path__ + "static/media/down-right-arrow-box.89ea16a23ff447269a001710a96e9aaf.svg";
export { ForwardRef as ReactComponent };